// Bloques de texto: título y texto plano (los saltos de línea se respetan;
// nunca HTML).

import type { SiteBlockOf } from "../values";

export function HeadingBlock({ block }: { block: SiteBlockOf<"heading"> }) {
  return <h1 className="text-xl font-semibold tracking-tight text-foreground @min-[40rem]:text-2xl">{block.text}</h1>;
}

export function TextBlock({ block }: { block: SiteBlockOf<"text"> }) {
  return <p className="whitespace-pre-line text-[15px] leading-relaxed text-muted-foreground">{block.text}</p>;
}
